import React, { useEffect, useState } from 'react'
import Header from '../../components/Header.jsx'
import SearchInput from '../../components/SearchInput.jsx'
import { authAxios } from '../../helpers/axios.js'
import { toast } from 'react-toastify'
import { useNavigate,useLocation, Link } from 'react-router-dom'
import { ErrorToast, InfoToast } from '../../helpers/toasters.js'
import { LIMIT } from '../../helpers/constants.js'
import SortIcon from '../../images/sort.svg'
import RightIcon from '../../images/right.svg'
import FilterIcon from '../../images/filter.svg'
import FilterActiveIcon from '../../images/filteractive.svg'
import ManageTea from './components/ManageTea.jsx'
import FilterBlendTea from './components/FilterBlendTea.jsx'

export default function BlendedTea() {
    const location = useLocation()
    const [searchText,setSearchText] = useState('')
    const [tealist,setTeaLists] = useState([])
    const [showCreate,setShowCreate] = useState({status:false,edit:null})
    const [exporting,setExporting] = useState(false)
    const navigate = useNavigate()

    const [cityFilters,setCityFilters] = useState([])
    const [routeFilters,setRouteFilters] = useState([])

    const [offset,setOffset] = useState(0);
    const [count,setCount] = useState(0)

    const [filters,setFilters] = useState({startDate:null,endDate:null,showEmpty:1})
    const [showFilters,setShowFilters] = useState(false)
    const [sort,setSort] = useState('-createdAt');
    const [submitting,setSubmitting] = useState(false)
    
    const onFilterSubmit = (filters)=>
    {
        try 
        {
            setFilters({...filters})
            setCount(5)
            setOffset(0)
            setShowFilters(false)
            const params = new URLSearchParams(location.search);
            if(filters.startDate) params.set('startDate',filters.startDate)
            else params.delete('startDate')
            if(filters.endDate) params.set('endDate',filters.endDate)
            else params.delete('endDate')
            if(filters) params.set('showEmpty',filters.showEmpty)
            else params.delete('showEmpty')
            navigate({ search: params.toString() });
        } catch (error) {
            toast('Blended Tea Filtered')
        }
    }

    const clearFilter = ()=>
    {
        try 
        {
            setFilters({startDate:null,endDate:null})
            setShowFilters(false)
            const params = new URLSearchParams(location.search);
            params.delete('startDate');
            params.delete('endDate');
            params.delete('showEmpty');
            navigate({ search: params.toString() });
        } catch (error) {
            toast('Blended Tea Filtered')
        }
    }

    const onSortPress = (type)=>
    {
        if (sort === type) {
            if(sort === `-${type}`) setSort(type)
            else setSort(`-${type}`);
            const params = new URLSearchParams(location.search);
            params.set('sort', sort.charAt(0) === '-' ? sort.slice(1) : sort);
            navigate({ search: params.toString() });
          } else {
            setSort(type);
            const params = new URLSearchParams(location.search);
            params.set('sort', type);
            navigate({ search: params.toString() });
          }
    }
    
    async function getTeaLists(search,sort,offset,filters){

        try 
        {
            let query = `&limit=${LIMIT}&offset=${offset}&sort=${sort}`;
                if(search) query+= `&search=${search}`;
                if(filters && filters.startDate) query+=`&startDate=${filters.startDate}`
                if(filters && filters.endDate) query+=`&endDate=${filters.endDate}`
                if(filters)
                    {
                        if(filters.showEmpty === 1 || filters.showEmpty === '1') query+=`&showEmpty=1`
                        else query+=`&showEmpty=0`

                    } 
            let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/blend?populate=true${query}`)
            if(res.data.data) 
            {
                setTeaLists(res.data.data)
                setCount(res.data.count)
            }
        } catch (error) {
            console.log(error)
            toast('Error getting tea list')
        }
    }

    useEffect(()=>
    {
        getTeaLists(searchText,sort,offset,filters)
    },[filters,searchText,offset,sort])

    const RightContent = ()=>
    {
        return <div>
          {/* <button type='button' disabled={exporting} className='btn-md mr-4' onClick={()=>exporttealist()}>{exporting ? 'Exporting...' : 'Export'}</button> */}
          <button type='button' className='btn-md' onClick={()=>setShowCreate({status:true,edit:null})}>Create Blended Tea</button>
        </div>
    }

    const onSubmit = async(e,data)=>
    {
        try 
        {
            e.preventDefault()
            setSubmitting(true)
            let res;
                res = await authAxios.post(`${process.env.REACT_APP_BASE_URL}/blend`,{...data,salesOrderId:data.salesOrderId?.id})
            InfoToast('Blend Created')

                await getTeaLists(searchText,sort,offset,filters)
                setShowCreate({status:false,edit:null})
            setSubmitting(false)
        } catch (error) {
            console.log(error)
            setSubmitting(false)
            ErrorToast(error.response?.data?.error)
        }
    }


    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const search = params.get('search') || '';
        const sort = params.get('sort') || '-createdAt';
        const offset = parseInt(params.get('offset')) || 0;
        const filters = {
            startDate: params.get('startDate') || null,
            endDate: params.get('endDate') || null,
            showEmpty: params.get('showEmpty') === 1 || params.get('showEmpty') === '1' ? 1 : 0
        };

        setSearchText(search);
        setSort(sort);
        setOffset(offset);
        setFilters(filters);
        navigate({ search: params.toString() });
        if (search !== '' || Object.values(filters).some(value => value !== null)) {
            getTeaLists(search, sort, offset, filters);
        }
    }, [location.search]);


    const onSearchChange = (value)=>
    {
        setSearchText(value);
        setOffset(0)
        const params = new URLSearchParams(location.search);
        params.set('search', value);
        params.set('offset', 0);
        navigate({ search: params.toString() });
    }

    const onPageChange = (newOffset)=>
    {
        if(newOffset >= 0 && newOffset < count){
            setOffset(newOffset);
            const params = new URLSearchParams(location.search);
            params.set('offset', newOffset);
            navigate({ search: params.toString() });
        }
    }

  return (
    <>
        <Header title={'Blended Tea Management'} RightContent={RightContent}/>
        <div className='flex justify-between items-stretch border-b border-[#e3e3e3] bg-white'>
        <div className='flex'>
                <SearchInput value={searchText} setValue={(value)=>onSearchChange(value)} placeholder={'Search Blended Tea'} label={'Search Blended Tea'} />
            <div className='flex w-full border-r items-center h-full justify-center text-center'>
                    <div className='px-2 hover:bg-[#f6f6f6] h-full cursor-pointer flex items-center flex-1 justify-center' onClick={()=>onPageChange(offset - LIMIT)}>
                        <img src={RightIcon} className='w-[20px] h-[20px] rotate-180'/>
                    </div>
                    <p className='text-xs whitespace-nowrap w-[80px] justify-center'>{offset + 1}-{Math.min(offset + LIMIT, count)} of {count}</p>
                    <div className='px-2 hover:bg-[#f6f6f6] h-full cursor-pointer flex items-center flex-1 justify-center' onClick={()=>onPageChange(offset + LIMIT)}>
                        <img src={RightIcon} className='w-[20px] h-[20px]'/>
                    </div>
                </div>
                </div>
                <div className='flex justify-end h-[100%] self-stretch items-center px-4 border-l border-[#e3e3e3] hover:bg-[#f6f6f6] cursor-pointer' onClick={()=>setShowFilters(true)}>
            {(filters.cityId || filters.routeId || filters.status) ? <img src={FilterActiveIcon} className={`w-[24px] h-[24px]`} alt='Filter' /> : <img src={FilterIcon} className={`w-[24px] h-[24px]`} alt='Filter' /> }
            </div>
        </div>
        <div className='flex-1 bg-white w-full flex overflow-scroll'>
            <table className='table-auto w-full flex-1'>
                <thead className='bg-[#f9f9f9] w-full'>
                    <tr className='w-full'>
                    <td><p onClick={()=>onSortPress('batchNumber')} className='cursor-pointer flex items-center hover:text-black'>Batch Number{sort === 'batchNumber' || sort === '-batchNumber'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>onSortPress('salesOrderId')} className='cursor-pointer flex items-center hover:text-black'>Sales Order / Buyer{sort === 'salesOrderId' || sort === '-salesOrderId'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>onSortPress('totalWeight')} className='cursor-pointer flex items-center hover:text-black'>Total Weight{sort === 'totalWeight' || sort === '-totalWeight'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>onSortPress('remainingWeight')} className='cursor-pointer flex items-center hover:text-black'>Remaining Weight{sort === 'remainingWeight' || sort === '-remainingWeight'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>onSortPress('bags')} className='cursor-pointer flex items-center hover:text-black'>Total Bags{sort === 'bags' || sort === '-bags'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>onSortPress('blendName')} className='cursor-pointer flex items-center hover:text-black'>Blend Name{sort === 'blendName' || sort === '-blendName'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
  
                    <td><p onClick={()=>onSortPress('status')} className='cursor-pointer flex items-center hover:text-black'>Status{sort === 'status' || sort === '-status'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                   
                    </tr>
                </thead>
                <tbody>
                    {
                        tealist.map((item,index)=>
                        {
                            return <Link to={`/blended-tea/${item.id}`} key={index}> 
                                <tr> 
                                <td className='capitalize'>
                                    <div className='flex'>
                                    <div>
                                        <p className='text-sm font-medium my-0'>#{item.batchNumber}</p>
                                    </div>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                    <div className='flex'>
                                    <div>
                                        <p className='text-sm font-medium my-0'>{item.salesOrder?.orderId ? `#${item.salesOrder.orderId}` : 'N/A'}</p>
                                        <p className='text-xs text-[#959595] font-medium my-0'>{item.salesOrder?.buyer?.name ? `${item.salesOrder.buyer?.name}` : 'N/A'}</p>
                                    </div>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                        <p className='text-sm font-medium my-0'>{item.totalWeight}</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                        <p className='text-sm font-medium my-0'>{item.remainingWeight}</p>
                                    </div>
                                </td>

                                <td className='capitalize'>
                                <div>
                                        <p className='text-sm font-medium my-0'>{item.bags} Bags</p>
                                    </div>
                                    </td>
                                <td className='capitalize'>
                                <div>
                                        <p className='text-sm font-medium my-0 capitalize'>{item.blendName ? item.blendName : 'N/A'}</p>
                                    </div>
                                </td>

                                <td className='capitalize'>
                                <div>
                                        <p className={`text-[13px] font-regular px-3 inline-block py-1 rounded-md ${item.status ===  1 ? 'text-[#454545] bg-gray-200 ' : item.status === 2 ? 'text-orange-600 bg-orange-100 ' : 'bg-[#39C7A5] bg-opacity-30 text-green-700 '}}`}>{item.status === 1 ? 'Created' : item.status === 2 ? 'Initiated' : item.status === 2 ? 'Completed' : 'Stored'}</p>
                                    </div>
                                </td>
                            </tr>
                            </Link>
                        })
                    }
                </tbody>
            </table>
        </div>
        { showCreate.status ? <ManageTea submitting={submitting} onClose={setShowCreate} onSubmit={onSubmit} edit={showCreate.edit}/> : null}
        {showFilters ? <FilterBlendTea filters={filters} onSubmit={onFilterSubmit} onClose={()=>setShowFilters(false)} clearFilter={clearFilter}/> : null}
    </>
  )
}

